/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const notificationProfileConfig = {
  updateProfileSuccess: {
    title: 'Woo hoo!',
    icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/happy-face-fhp.png',
    description: ['Profile has been updated Successfully'],
    acknowledgementButtonText: 'Close',
  },
};
